import React, { useEffect, useMemo } from "react";
import Logo from "../../assets/logo.png";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../store/apis/users";
import UserMenuItem from "./userMenuItem";
import "./index.scss";

function Navbar({ authUser }) {
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const newUser = useSelector((state) => state.user.user);
  const state = useSelector((state) => state);

  useMemo(() => {
    if (
      authUser != null &&
      (!userState || !userState.user || !userState.user._id)
    ) {
      const userId = JSON.parse(authUser).user;
      dispatch(getUser(userId));
    }
  }, [authUser]);

  return (
    <div className="navbar-container">
      <Row className="row-container">
        <Col xs={12} sm={12} md={10} lg={8} xl={8}>
          <div className="logo-section">
            <Link to="/">
              <img src={Logo} />
            </Link>
          </div>
        </Col>
        {!userState?.isLogged && !authUser ? (
          <Col xs={12} sm={12} md={14} lg={16} xl={16}>
            <div className="links-section">
              {/* <Link to="/about"> من نحن </Link> */}
              <Link to="/login"> تسجيل دخول </Link>
              <Link to="/register" className="register-btn">
                إنشاء حساب
              </Link>
            </div>
          </Col>
        ) : (
          <Col xs={12} sm={12} md={14} lg={16} xl={16}>
            <div className="auth-navbar-links">
              <Link onClick={(e) => e.preventDefault()}>
                <div className="navbar-links">
                  <UserMenuItem
                    username={
                      userState?.user?.username || newUser?.user?.username
                    }
                  />
                </div>
              </Link>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
}

export default Navbar;
